var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk237430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.7 30",
    style: {
      enableBackground: "new 0 0 87.7 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4694 -0.883 0.883 0.4694 0.5398 16.0246)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.8,
    transform: "matrix(0.8676 -0.4973 0.4973 0.8676 -8.7798 9.6963)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2,30H0V0h30.2V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8,25.9H4V3.7h22.8V25.9z M5.1,24.8h20.5V4.8H5.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8,
    y: 7,
    transform: "matrix(0.8832 -0.469 0.469 0.8832 5.1054 35.6281)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 7.1,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 18.635 74.8246)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,30H57.5V0h30.2V30z M58.7,28.8h27.9V1.2H58.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,25.9H60.9V3.7h22.8V25.9z M62.1,24.8h20.5V4.8H62.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 7,
    transform: "matrix(0.8828 -0.4697 0.4697 0.8828 1.7601 22.1813)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 7.1,
    transform: "matrix(0.497 -0.8677 0.8677 0.497 4.1857 49.8897)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,30H28.7V0h30.2V30z M29.9,28.8h27.9V1.2H29.9V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,25.9H32.2V3.7H55V25.9z M33.3,24.8h20.5V4.8H33.3V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,30l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l0.7-1.6c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-0.7,1.6 C1.5,29.9,1.2,30,1,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,25.9l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l1.4-3.3c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1.4,3.3 C3.3,25.8,3,25.9,2.8,25.9z M5.3,20.2l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l1.4-3.3c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8 l-1.4,3.3C5.8,20.1,5.6,20.2,5.3,20.2z M7.9,14.5l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l1.4-3.3c0.1-0.3,0.5-0.4,0.8-0.3 c0.3,0.1,0.4,0.5,0.3,0.8l-1.4,3.3C8.3,14.4,8.1,14.5,7.9,14.5z M10.4,8.8l-0.2,0C9.9,8.6,9.7,8.3,9.9,8l1.4-3.3 c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1.4,3.3C10.8,8.7,10.6,8.8,10.4,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9,3.1l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l0.7-1.6c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-0.7,1.6 C13.3,3,13.1,3.1,12.9,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,30c-0.2,0-0.4-0.1-0.5-0.3l-1.7-3.2c-0.2-0.3,0-0.6,0.2-0.8c0.3-0.2,0.6,0,0.8,0.2l1.7,3.2c0.2,0.3,0,0.6-0.2,0.8 L28.9,30z M25.9,24.5c-0.2,0-0.4-0.1-0.5-0.3L23.7,21c-0.2-0.3,0-0.6,0.2-0.8c0.3-0.2,0.6,0,0.8,0.2l1.7,3.2c0.2,0.3,0,0.6-0.2,0.8 L25.9,24.5z M23,19c-0.2,0-0.4-0.1-0.5-0.3l-1.7-3.2c-0.2-0.3,0-0.6,0.2-0.8c0.3-0.2,0.6,0,0.8,0.2l1.7,3.2c0.2,0.3,0,0.6-0.2,0.8 L23,19z M20,13.4c-0.2,0-0.4-0.1-0.5-0.3L17.8,10c-0.2-0.3,0-0.6,0.2-0.8c0.3-0.2,0.6,0,0.8,0.2l1.7,3.2c0.2,0.3,0,0.6-0.2,0.8 L20,13.4z M17.1,7.9c-0.2,0-0.4-0.1-0.5-0.3l-1.7-3.2c-0.2-0.3,0-0.6,0.2-0.8c0.3-0.2,0.6,0,0.8,0.2l1.7,3.2c0.2,0.3,0,0.6-0.2,0.8 L17.1,7.9z M14.1,2.4c-0.2,0-0.4-0.1-0.5-0.3l-0.5-0.9c-0.2-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2l0.5,0.9 c0.2,0.3,0,0.6-0.2,0.8L14.1,2.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk237430);
export default __webpack_public_path__ + "static/media/AK2_3_743_0.bb0c030adc9d48ea4a511f78eec8e293.svg";
export { ForwardRef as ReactComponent };